import { defaultColumns, defaultSort } from '../../components/data/customerPriceLists/columns';

export default {
  state: {
    customerPriceLists: [],
    tableConfig: null,
    loading: false,
    currentPage: 1,
    filterString: null,
    sorting: {
      prop: 'name',
      order: 'ascending',
    },
  },
  getters: {
    customerPriceLists: state => state.customerPriceLists,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
  },
  mutations: {
    setCustomerPriceLists(state, customerPriceLists) {
      state.customerPriceLists = customerPriceLists;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/customer-price-lists-list');
        if (setting.id) {
          const tableConfig = {
            id: setting.id,
            type: 'customer-price-lists-list',
            columns: JSON.parse(setting.config).columns,
            sort: JSON.parse(setting.config).sort,
          };
          commit('setTableConfig', tableConfig);
        } else {
          const tableConfig = {
            type: 'customer-price-lists-list',
            columns: defaultColumns,
            sort: defaultSort,
          };
          commit('setTableConfig', tableConfig);
        }
      } catch (e) {
      }
    },
    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&${state.filterString}`;
        const customerPriceLists = await axios.get('api/customer-price-lists' + (query || ''));
        commit('setCustomerPriceLists', customerPriceLists);
      } catch (e) {
        console.log(e);
      }
      commit('setLoading', false);
    },

    async fetch({ commit }, id) {
      return await axios.get(`api/customer-price-lists/${id}`);
    },
    async create({ commit }, payLoad) {
      await axios.post('api/customer-price-lists', payLoad);
    },
    async update({ commit }, payLoad) {
      await axios.put('api/customer-price-lists', payLoad);
    },

    async delete({ commit }, id) {
      await axios.delete('api/customer-price-lists/' + id);
    },

    async excelExport({ commit }, { data, fileName, fileFormat }) {
      const excel = await axios({
        url: 'api/customer-price-lists/export',
        method: 'POST',
        responseType: 'blob',
        data,
      });
      saveAs(excel, `${fileName.trim().split(' ').join('_') || 'CustomerPriceList'}.${fileFormat.toLocaleLowerCase() || 'xlsx'}`);
    },
  },
};
